import i18next from 'i18next'

i18next.addResourceBundle('en', 'email', {
    email_server_configuration: 'Email server configuration',
    enable_verification: 'Enable email address verification',
    url: 'URL',
    username: 'Username',
    password: 'Password',
    email_server_configuration_deleted: 'Email server configuration deleted',
    email_server_configuration_saved: 'Email server configuration saved',
    confirm_change_email_settings: 'Are you sure you want to change email settings',
    confirm_change_email_settings_message: 'All users working with OpenL Studio now will lose all unsaved changes. Are you sure you want to change email settings now?',
})
